import { useState, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { normalizeStateMap, transformBinds } from './utils';

export const useBindsData = (binds) => {
  const queryClient = useQueryClient();
  const [companyBinds, setCompanyBinds] = useState([]);
  const [houseBinds, setHouseBinds] = useState([]);
  const [roomBinds, setRoomBinds] = useState([]);
  const [initFormState, setInitFormState] = useState(new Map());
  const [prevBinds, setPrevBinds] = useState({
    companies: new Set(),
    houses: new Set(),
    actualHouses: new Set(),
    addresses: new Set(),
    boundHouses: new Set(),
  });

  useEffect(() => {
    let isCancelled = false;

    const setBindsData = async () => {
      const { companyBinds, houseBinds, roomBinds, stateMap, prevBinds } =
        transformBinds(binds);
      const normalizedStateMap = await normalizeStateMap({
        stateMap,
        queryClient,
      });

      if (isCancelled) return;

      setCompanyBinds(companyBinds);
      setHouseBinds(houseBinds);
      setRoomBinds(roomBinds);
      setInitFormState(normalizedStateMap);
      setPrevBinds(prevBinds);
    };

    setBindsData();

    return () => {
      isCancelled = true;
    };
  }, [binds, queryClient]);

  return {
    companyBinds,
    houseBinds,
    roomBinds,
    initFormState,
    prevBinds,
  };
};
